import { Group, Text } from '@mantine/core'
import { ReactNode } from 'react'
import { useDeviceDetect } from '@/hooks/useDeviceDetect'

type FixedPageTitleProps = {
  title: ReactNode
  icon?: ReactNode
  leftSection?: ReactNode
  rightSection?: ReactNode
}

export const FixedPageTitle = ({
  title,
  icon,
  leftSection,
  rightSection
}: FixedPageTitleProps) => {
  const { isMobile } = useDeviceDetect()

  return (
    <Group align="center" justify="space-between">
      {/* flex={1} expands to fill space, miw={0} allows shrinking below content width for text truncation */}
      <Group gap={isMobile ? 'sm' : 'lg'} wrap="nowrap" flex={1} miw={0}>
        {icon}

        <Text component="h2" fw={700} fz={isMobile ? 16 : 24} truncate>
          {title}
        </Text>

        {leftSection}
      </Group>

      {rightSection}
    </Group>
  )
}
